import React from "react";
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import type {ChangeStep} from "~/prototypes/pages/taxonomy-canvas/approval/changeSteps.ts";
import {TaxonomyChangeRow} from "~/prototypes/pages/taxonomy-canvas/approval/TaxonomyChangeRow.tsx";

type Props = {
    steps: ChangeStep[]
    onAccept: (editKey: number) => void
    onReject: (editKey: number) => void
}
/** The pending changes in the order they were made, one row each */
export const TaxonomyChangeList: React.FC<Props> = ({steps, onAccept, onReject}) =>
    <TableContainer component={Paper} variant="outlined">
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell padding="checkbox"/>
                    <TableCell>#</TableCell>
                    <TableCell>Change</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Author</TableCell>
                    <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Accept / Reject</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {steps.map((step, i) =>
                    <TaxonomyChangeRow
                        key={step.edit.key}
                        step={step}
                        index={i}
                        onAccept={() => onAccept(step.edit.key)}
                        onReject={() => onReject(step.edit.key)}
                    />
                )}
            </TableBody>
        </Table>
    </TableContainer>;
